/*
 * opening act. — Phones/tablets: pull the header MENU and the header SEARCH
 * up to close them - a grip at the bottom edge. The panel folds up the same
 * way the X closes it (window.oaSheet, assets/global.js): its lower edge
 * follows the finger while the content stays put and the corner fillets stay
 * at the header. Released past a quarter of its height / 10rem, or flicked,
 * the X's closing sheet takes over FROM WHERE THE EDGE IS (header white
 * folds with it); otherwise it springs back.
 * Not while the dock owns the panel (html.oa-sheet-up: that sheet comes up
 * from the bottom and is pulled DOWN, snippets/oa-mobile-dock.liquid).
 */
(function () {
  if (window.__oaPullUp) return;
  window.__oaPullUp = true;
  var de = document.documentElement;
  var EASE = 'cubic-bezier(0.6, 0, 0.4, 1)';

  function openDetails(sel) { return document.querySelector(sel); }
  var PANELS = [
    {
      // menu: <header-drawer><details open>…<div id="menu-drawer">
      panel: function () {
        var d = openDetails('header-drawer details#Details-menu-drawer-container[open]');
        return d && d.querySelector('#menu-drawer');
      },
      close: function () {
        var hd = document.querySelector('header-drawer');
        var s = hd && hd.querySelector('summary.header__icon--menu');
        if (hd && typeof hd.closeMenuDrawer === 'function') hd.closeMenuDrawer(new Event('oa-pull'), s);
      },
      left: false, // flush with the screen's left edge: fillet + rounded corner on the right only
    },
    {
      // search: <details-modal class="header__search"><details open>…<div class="search-modal">
      panel: function () {
        var all = document.querySelectorAll('details-modal.header__search details[open] .search-modal');
        for (var i = 0; i < all.length; i++) if (all[i].offsetParent !== null || all[i].getClientRects().length) return all[i];
        return null;
      },
      close: function (panel) {
        var dm = panel.closest('details-modal');
        if (dm && typeof dm.close === 'function') dm.close();
      },
      left: true,
    },
  ];

  function live() { return window.innerWidth < 990 && !de.classList.contains('oa-sheet-up'); }

  // the grip (bar at the bottom edge) - added whenever a panel is open
  function addGrips() {
    PANELS.forEach(function (p) {
      var el = p.panel();
      if (el && !el.querySelector(':scope > .oa-pull-grip')) {
        var g = document.createElement('span');
        g.className = 'oa-pull-grip';
        g.setAttribute('aria-hidden', 'true');
        el.appendChild(g);
      }
    });
  }
  new MutationObserver(function () { addGrips(); })
    .observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['open'] });

  function canScrollOn(t, el) {
    for (var n = t; n && n !== el.parentElement; n = n.parentElement) {
      var o = getComputedStyle(n).overflowY;
      if ((o === 'auto' || o === 'scroll') && n.scrollTop + n.clientHeight < n.scrollHeight - 1) return true;
      if (n === el) break;
    }
    return false;
  }
  function rem() { return parseFloat(getComputedStyle(document.documentElement).fontSize) || 10; }
  // the same clip the opening/closing sheet uses: q = visible px of panel
  // (+ its 5rem shadow); full = inset(0 -2rem -5rem -2rem)
  // While the finger holds it, the rising lower edge keeps the panel's
  // rounded corners, and the inverted fillets at the header (the panel's
  // ::before/::after, just outside its sides) stay visible - a plain inset()
  // cut the corners square. So: a path, panel width w, visible height y.
  function clipFor(q, el, left) {
    var w = el.offsetWidth, P = el.offsetHeight;
    if (q >= P) return 'inset(0px -2rem calc(100% - ' + q.toFixed(2) + 'px) -2rem)';
    var y = Math.max(0, q), f = 1.6 * rem(), r = Math.min(f, y / 2), fh = Math.min(f + 2, y);
    var o = 2 * rem(); // room for the fillets beside the panel
    var d = 'M ' + (left ? -o : 0) + ' 0 H ' + (w + o) + ' V ' + fh + ' H ' + w +
      ' V ' + (y - r) + ' A ' + r + ' ' + r + ' 0 0 1 ' + (w - r) + ' ' + y +
      ' H ' + (left ? r : 0) +
      (left ? ' A ' + r + ' ' + r + ' 0 0 1 0 ' + (y - r) + ' V ' + fh + ' H ' + (-o) : ' V 0') + ' Z';
    return 'path("' + d + '")';
  }
  function setClip(el, tr, clip) {
    el.style.setProperty('transition', tr, 'important');
    el.style.setProperty('clip-path', clip, 'important');
    el.style.setProperty('-webkit-clip-path', clip, 'important');
  }
  function clear(el) {
    ['transition', 'clip-path', '-webkit-clip-path'].forEach(function (p) { el.style.removeProperty(p); });
  }

  var cur = null, sx = 0, sy = 0, dy = 0, lastY = 0, lastT = 0, v = 0, on = false, decided = false, blocked = true, full = 0;
  document.addEventListener('touchstart', function (e) {
    blocked = true;
    cur = null;
    if (!live() || e.touches.length !== 1) return;
    for (var i = 0; i < PANELS.length; i++) {
      var el = PANELS[i].panel();
      if (el && el.contains(e.target)) { cur = { p: PANELS[i], el: el }; break; }
    }
    if (!cur) return;
    // still opening (sheet running) or typing in the search field: leave alone
    if (cur.el.__oaRun && cur.el.__oaRun.live) return;
    if (e.target.closest && e.target.closest('input, textarea, select')) return;
    var t = e.touches[0];
    sx = t.clientX; sy = lastY = t.clientY; lastT = e.timeStamp;
    dy = 0; v = 0; on = false; decided = false;
    full = cur.el.offsetHeight + rem() * 5;
    blocked = !e.target.closest('.oa-pull-grip') && canScrollOn(e.target, cur.el);
    listen(true);
  }, { passive: true, capture: true });

  // Non-passive move listener only for the touch that started on an open
  // panel - a permanent one on the document makes the browser wait for
  // script before every page scroll (laggy scrolling on phones).
  function onMove(e) {
    if (blocked || !cur) return;
    var t = e.touches[0];
    var ddy = sy - t.clientY, ddx = t.clientX - sx;
    if (!decided) {
      if (Math.abs(ddy) < 6 && Math.abs(ddx) < 6) return;
      decided = true;
      if (ddy <= 0 || Math.abs(ddx) > Math.abs(ddy)) { blocked = true; return; }
      on = true;
    }
    if (!on) return;
    e.preventDefault();
    dy = Math.min(Math.max(0, ddy), full - 1);
    var dt = Math.max(1, e.timeStamp - lastT);
    v = (lastY - t.clientY) / dt;
    lastY = t.clientY; lastT = e.timeStamp;
    setClip(cur.el, 'none', clipFor(full - dy, cur.el, cur.p.left));
  }
  function listen(on) {
    if (on) document.addEventListener('touchmove', onMove, { passive: false, capture: true });
    else document.removeEventListener('touchmove', onMove, { passive: false, capture: true });
  }

  function end() {
    listen(false);
    if (!on || !cur) return;
    on = false;
    var c = cur, node = c.el;
    var h = node.offsetHeight;
    if (dy > Math.min(100, h * 0.25) || (v > 0.45 && dy > 24)) {
      // Hand over to the X's closing sheet, starting where the edge is now:
      // window.oaSheet carries on from a live run's position.
      var q = Math.max(1, full - dy);
      node.__oaRun = { live: true, pos: function () { return { h: 0, q: q }; }, stop: function () { this.live = false; } };
      c.p.close(node);
      if (node.__oaRun && node.__oaRun.pos && node.__oaRun.pos().q === q) node.__oaRun = null; // nobody took it (no sheet)
      clear(node);
    } else {
      // spring back: the edge runs down again (path shapes don't animate:
      // stepped by frames)
      var from = full - dy, t0 = performance.now();
      (function back() {
        var k = Math.min(1, (performance.now() - t0) / 280), e2 = 1 - Math.pow(1 - k, 3);
        setClip(node, 'none', clipFor(from + (full - from) * e2, node, c.p.left));
        if (k < 1) requestAnimationFrame(back); else clear(node);
      })();
    }
  }
  document.addEventListener('touchend', end, { capture: true });
  document.addEventListener('touchcancel', end, { capture: true });
})();
